import apiRequest from '@/http/api-request'
import authService from '@/auth/authService'

export default {
  fetchCharities({commit}) {

    return new Promise((resolve, reject) => {
      apiRequest.doGetRequest(`/client/charities`, {}, {'X-Harness-JWT': authService.getToken()}, {skipCache: true})
        .then((charities) => {
          commit('SET_CHARITIES', charities)
          resolve(charities)
        })
        .catch((error) => reject(error))
    })
  },
  fetchCharityConfig({commit}, {charityId}) {
    return new Promise((resolve, reject) => {
      apiRequest.doGetRequest(`/whitelabel/${charityId}/config`)
        .then((response) => {
          commit('SET_ACTIVE_CHARITY_INFO', response)
          resolve(response)
        })
        .catch((error) => reject(error))
    })
  },
}
